import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'sortStrings' })
export class SortStringPipe implements PipeTransform {
	transform(value: string[], args: string[]): any {
		return value.sort();
	}
}



// WEBPACK FOOTER //
// ./src/app/ui-helper/sort-string.pipe.ts